import type { CompanyFilters } from "../../types";
import type { TargetOrganizationsSlice } from "./slice";

export function toCompanyFilters(
  slice: TargetOrganizationsSlice
): Partial<CompanyFilters> {
  const out: Partial<CompanyFilters> = {};

  if (slice.hgIds.length > 0) {
    out.hgIds = slice.hgIds;
  }

  if (slice.hgIdsIncludingCorporateRelatives.length > 0) {
    out.hgIdsIncludingCorporateRelatives =
      slice.hgIdsIncludingCorporateRelatives;
  }

  return out;
}

export function fromCompanyFilters(
  filters: CompanyFilters
): TargetOrganizationsSlice {
  return {
    hgIds: (filters.hgIds ?? []).filter((id): id is string => id != null),
    hgIdsIncludingCorporateRelatives: (
      filters.hgIdsIncludingCorporateRelatives ?? []
    ).filter((id): id is string => id != null),
    companiesCache: [],
  };
}
